import React, { createContext, useContext } from 'react';

export const BitbucketContext = createContext<any>(undefined);

export const useBitbucketContext = () => {
  const context = useContext(BitbucketContext);

  if (!context) {
    throw new Error('context has not been setup');
  }

  return context;
};

export const BitbucketContextProvider = ({ children, value }: any) => {
  return <BitbucketContext.Provider value={value}>{children}</BitbucketContext.Provider>;
};
